<template>
  <div v-if="slides.length" id="carousel" ref="carousel">
    <swiper ref="mySwiper" :options="swiperOption" class="swiper-big-wrapper">
      <swiper-slide v-for="(item, key) in slides" :key="key" class="swiper-slide">
        <a class="img swiper-lazy" :href="item.url" :data-background="item.img_thumb">
          <div v-if="item.title" class="text-container">
            <h1>{{ item.title }}</h1>
          </div>
        </a>
      </swiper-slide>
      <div id="pagination" slot="pagination" class="swiper-pagination" />
    </swiper>
  </div>
</template>

<script>
import { Swiper, SwiperSlide, directive } from "vue-awesome-swiper"
import "swiper/css/swiper.min.css"

export default {
  name: "Carousel",
  components: { Swiper, SwiperSlide },
  directives: {
    swiper: directive
  },
  data() {
    return {
      slides: [],
      swiperOption: {
        lazy: {
          loadPrevNext: true,
        },
        spaceBetween: 0,
        speed: 700,
        autoplay: {
          delay: 3000,
        },
        loop: true,
        pagination: {
          el: ".swiper-pagination",
          type: "bullets",
        },
      },
    }
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper
    },
  },
  created() {
    this.getCarousel()
  },
  methods: {
    getCarousel() {
      this.$axios(window.PHP_ROOT + "/index/api/ad")
        .then(({ data }) => {
          if (data.code === "1000") {
            this.slides = data.msg
            this.setWidth()
          }
        })
        .catch(err => {
          throw new Error(err)
        })
    },
    setWidth() {
      this.$nextTick(() => {
        const width = window.innerWidth * 0.9 / 2.35
        this.$refs.carousel.style.height = width
      })
    }
  },
}
</script>

<style lang="scss">
#carousel {
  width: 100%;
  margin: 0 auto 15px auto;
  height: 160px;
  $radius: 4px;
  .swiper-big-wrapper {
    width: 100%;
    height: 100%;
    margin: auto;
    .swiper-scrollbar {
      width: 90%;
      margin: 0 5%;
    }
    #pagination {
      bottom: 3px;
      width: 90%;
      margin: 0 5%;
    }
    .swiper-pagination-bullet {
      transform: scale(0.9);
      width: 12px;
      height: 2px;
      border-radius: 0;
      display: inline-block;
      background: white;
      opacity: 0.5;
    }
    .swiper-pagination-bullet-active {
      background: white;
      opacity: 1;
    }
    .swiper-slide {
      .img {
        border-radius: $radius;
        display: block;
        height: 100%;
        margin: auto;
        width: 90%;
        background-position: center;
        background-size: cover;
        background-color: #eee;

        img {
          height: 100%;
          width: 100%;
        }
        .text-container {
          width: 100%;
          height: 100%;
          background-image: linear-gradient(rgba(0, 0, 0, 0) 55%, rgba(0, 0, 0, 0.6));
          border-bottom-left-radius: $radius;
          border-bottom-right-radius: $radius;
          @include avenir();
          h1 {
            font-weight: 500;
            width: 80%;
            font-size: 1rem;
            color: white;
            position: absolute;
            bottom: 4%;
            left: 10vw;
            line-height: 1.4;
          }
        }
      }
    }
  }
}

// iPhone 5
@media screen and (max-width: 320px) {
  #carousel {
    height: 136px;
    .swiper-big-wrapper .swiper-slide .img .text-container h1 {
      font-size: 15px;
    }
  }
}

// iPhone 6
@media screen and (min-width: 320px) {
  #carousel {
    height: 143px;
  }
}

// iPhone 6 plus
@media screen and (min-width: 414px) {
  #carousel {
    height: 158px;
  }
}

// iPad
@media only screen and (min-device-width: 768px) {
  #carousel {
    height: 294px;
    .swiper-big-wrapper .swiper-slide .img .text-container h1 {
      // font-size: 20px;
    }
  }
}

// iPad Pro
@media only screen and (min-width: 1024px) {
  #carousel {
    height: 392px;
  }
}
</style>
